<template>
  <div class="modal-container" @click="$router.back()">
    <modal-base>
      <div class="modal-body">
        <div class="modal-name">
          <h2>{{ this.personDetail.name }}</h2>
          <p v-if="this.personDetail.birthday && this.personDetail.place_of_birth"><span class="modal-birth">Born on {{ this.personDetail.birthday }} in {{ this.personDetail.place_of_birth }}.</span></p>
        </div>
        <vue-scroll>
          <div v-if="this.personDetail.biography" class="modal-biography">
            <p>{{ this.personDetail.biography }}</p>
          </div>
        </vue-scroll>
      </div>
    </modal-base>
  </div>
</template>

<script>
export default {
    data() {
      return {
        personId: this.$route.params.id,
        personDetail: {},
      };
    },
    created() {
      fetch(`https://api.themoviedb.org/3/person/${this.personId}?api_key=7e87347114ccb7e8746f73f84d249ab2&language=en-US`)
        .then(
          (response) => {
            response.json()
              .then(
                (data) => {
                  this.personDetail = data;
                }
              )
          }
        )
    },
  };
</script>

<style scoped>
  .modal-container {
    height: calc(100vh - 68px);
    padding: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal-body {
    height: 100%;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .modal-name {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  h2 {
    width: 100%;
    margin-block-start: 0;
    margin-block-end: 0;
    text-transform: uppercase;
    text-align: center;
    font-size: 28px;
    border-bottom: 1px solid #0C1E7F;
  }

  .modal-birth {
    margin-block-start: 0;
    margin-block-end: 0;
    font-style: italic;
  }

  .modal-biography {
    max-height: 500px;
    text-align: justify;
  }

  @media (max-width: 499px) {
    .modal-container {
      height: calc(100vh - 68px);
      padding: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .modal-body {
      height: 100%;
      padding: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }

    .modal-name {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    h2 {
      width: 100%;
      margin-block-start: 0;
      margin-block-end: 0;
      text-transform: uppercase;
      text-align: center;
      font-size: 16px; /* MODIFIED */
      border-bottom: 1px solid #0C1E7F;
    }

    .modal-birth {
      margin-block-start: 0;
      margin-block-end: 0;
      font-style: italic;
    }

    .modal-biography {
      max-height: 500px;
      text-align: justify;
      font-size: 12px; /* MODIFIED */
    }
  }
</style>
